// Qiankun env variables injection
if (window.__POWERED_BY_QIANKUN__) {
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
}

import Vue from "vue";
import "whatwg-fetch";
import VueI18n from "vue-i18n";
import router from "@root/router";
import store from "@root/store";
import { createProvider } from "@root/apollo/vue-apollo.js";
import apolloOptions, {
  gqlClient as apolloClient
} from "@root/apollo/apollo-options";
import ElementUI from "element-ui";
import GTechUI from "@gtech/gtech-ui";
import directives from "@root/lib/directives";
import i18n from "@root/i18n";
import components from "@root/components";
import ddQuery from "@root/utiles/ddQuery";
import clipboard from "@root/utiles/clipboard";
import safeJoin from "@root/utiles/safeJoin";
import VueClipboard from "vue-clipboard2";
import App from "./App.vue";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import { actionInit, registerMicroApps, Login } from "@root/lib/qiankun";
import { initGlobalStates } from "@root/lib/qiankun/initStates";

// Application configure
import appConfigure from "@/options.ts";

// Sheets
import "@gtech/gtech-ui/dist/theme-chalk/index.css";
import "@root/sheet/element-ui-rebuild.css";
import "@root/sheet/index.scss";

// Sentry
// TODO: qiankun子应用是否冲突
if (
  process.env.NODE_ENV === "production" &&
  process.env.SENTRY_ENABLE === "TRUE"
) {
  Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DSN || "",
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    release: process.env.RELEASE_DATE
  });
}

// Config
Vue.config.productionTip = false;
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(directives);
Vue.use(clipboard);
Vue.use(ddQuery, { i18n, store });
Vue.use(GTechUI);
Vue.use(VueI18n);
Vue.use(components);
Vue.use(ElementUI, {
  i18n: (key: any, value: any) => i18n.t(key, value),
  Select: { props: { filterable: true } }
});
Vue.use(safeJoin);

// Instance
let instance = null;
function render(props: any = {}) {
  const { container } = props;
  const apolloProvider = createProvider(apolloOptions);

  instance = new Vue({
    router,
    store,
    i18n: i18n,
    provide: apolloProvider,
    render: h => h(App)
  }).$mount(container ? container.querySelector("#app") : "#app");
}

// Qiankun config
// qiankun-micro-app: 应用初始化的时候调用
export async function bootstrap(props) {
  console.log(`${process.env.APP_NAME} bootstrap`);
}

// qiankun-micro-app: 应用每次进入都会调用 mount 方法，通常我们在这里触发应用的渲染方法
export async function mount(props) {
  console.log(`${process.env.APP_NAME} mount`);
  let { mainRouter } = props;
  if (mainRouter) {
    store.commit("root/SET_MAIN_ROUTER", mainRouter);
  }
  // let logionOptions = props.loginOptions();
  // let loginAuto = new Login();

  // let authCode = await loginAuto.getAuthCode(logionOptions);

  // let { authToken } = await loginAuto.loginByAuthCode({
  //   apolloClient,
  //   authCode
  // });

  // TODO: localStroge 冲突的可能性
  // localStorage.setItem("AuthToken", authToken);

  actionInit(props);

  render(props);
}

// qiankun-micro-app: 应用每次退出卸载会调用的方法，通常在这里我们会卸载微应用的应用实例
export async function unmount() {
  console.log(`${process.env.APP_NAME} unmount`);

  instance.$destroy();
  instance.$el.innerHTML = "";
  instance = null;
}

if ((appConfigure.config as any).microApps) {
  registerMicroApps((appConfigure.config as any).microApps);
  initGlobalStates();
}

// render whitout qiankun
if (!window.__POWERED_BY_QIANKUN__) {
  render();
}
